<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'

// autoUpdate would swap in the new service worker silently on some future
// load, leaving an already-open tab running stale cached code indefinitely.
// 'prompt' registration surfaces needRefresh instead, so we can tell the
// user and let them choose when to reload onto the new version.
const { needRefresh, updateServiceWorker } = useRegisterSW()

function refresh(): void {
  void updateServiceWorker(true)
}

function dismiss(): void {
  needRefresh.value = false
}
</script>

<template>
  <div
    v-if="needRefresh"
    role="status"
    class="fixed inset-x-4 bottom-[max(1rem,env(safe-area-inset-bottom))] z-50 mx-auto flex max-w-[420px] items-center justify-between gap-3 rounded-2xl border border-outline-variant bg-surface-container-low p-4 shadow-lg"
  >
    <p class="font-sans text-[13px] leading-[1.5] text-on-surface">
      A new version is available.
    </p>
    <div class="flex shrink-0 items-center gap-2">
      <button
        type="button"
        class="h-10 rounded-full px-4 font-mono text-[13px] font-medium text-on-surface"
        @click="dismiss"
      >
        Dismiss
      </button>
      <button
        type="button"
        class="h-10 rounded-full bg-primary px-4 font-mono text-[13px] font-medium text-on-primary"
        @click="refresh"
      >
        Refresh
      </button>
    </div>
  </div>
</template>
